<template>
  <div class="container">
    <a-modal title="添加子预算" :visible="subVisible" @cancel="closeSub" width="40%">
        <template slot="footer">
				<a-button key="back" @click="closeSub"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="subAdd" v-if="type == 0"> 确定 </a-button>
			</template>
      <div class="center">
         <div class="centerBox">
            <div class="view" v-if="addType == 1">
              <div class="ico">
                <a-icon class="circle" type="info-circle" />
              </div>
              <div class="hiteBox">
                <!-- <div class="hb">说明</div> -->
                <div class="hite">当前批量是在为本【计划中】全部部门进行维护。如重复进行批量操作，新设置的内容将覆盖原有数据</div>
              </div>
          </div>
        <div  class="top">
          <a-input-search v-model="queryParam" style="width: 70%;margin-bottom: 8px" placeholder="请输入名称" @change="onChange" />
          <!-- <a-button  type="primary" style="margin-left: 10px;" @click="addSub" v-if="type == 0"> 添加 </a-button> -->
          <!-- <a-button key="back" type="primary" style="margin: 10px 0 0 10px;" @click="allSelect"> 全选 </a-button>
          <a-button key="back" type="primary" style="margin-top: 10px" @click="clearSelect"> 清楚全部 </a-button> -->
        </div>
        <div class="bottom">
            <!-- :checkStrictly="checkStrictly" -->
          <a-tree
            :tree-data="subTree"
            show-icon1  
            default-expand-all
            :replace-fields="replaceFields"
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            checkable
            v-model="checkedSub"
            @check="onCheck"
            @expand="onExpand"
            :disabled="type == 1"
          >
            <template slot="custom" slot-scope="item">
              <span class="redd" v-if="item.name.indexOf(searchValue) > -1">
                {{ item.name.substr(0, item.name.indexOf(searchValue)) }}
                <span style="color: #f50">{{ searchValue }}</span>
                {{ item.name.substr(item.name.indexOf(searchValue) + searchValue.length) }}
              </span>
              <span v-else>{{ item.name }}</span>
            </template>
          </a-tree>
        </div>
      </div>
      <div class="centerRight">
          <a-table
              :data-source="subList"
               bordered
              :pagination='false'
              :scroll="{ x: 2200, y: 490 }"
            >
              <a-table-column key="BaseInformation.name" data-index="BaseInformation.name" title="预算范围" v-if="flag == false" >
                <template scope="text, record">
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span>{{text}}</span> 
                    <a-button type="link" icon="close" style="color:red;" @click="deleteItem(record)"/>  
                  </div>
                </template>
              </a-table-column>
              <a-table-column key="name" data-index="name" title="预算范围"  v-else>
                <template scope="text, record">
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span>{{text}}</span> 
                    <a-button type="link" icon="close" style="color:red;" @click="deleteItem(record)"/>  
                  </div>
                </template>
              </a-table-column>
              <a-table-column key="month1" data-index="month1" :title="keyYear + '年1月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month1" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month2" data-index="month2" :title="keyYear + '年2月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month2" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month3" data-index="month3" :title="keyYear + '年3月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month3" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month4" data-index="month4" :title="keyYear + '年4月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month4" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month5" data-index="month5" :title="keyYear + '年5月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month5" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month6" data-index="month6" :title="keyYear + '年6月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month6" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month7" data-index="month7" :title="keyYear + '年7月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month7" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month8" data-index="month8" :title="keyYear + '年8月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month8" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month9" data-index="month9" :title="keyYear + '年9月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month9" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month10" data-index="month10" :title="keyYear + '年10月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month10" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month11" data-index="month11" :title="keyYear + '年11月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month11" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
              <a-table-column key="month12" data-index="month12" :title="keyYear + '年12月'" >
                <template scope="text,record">
                  <a-input class="aInput" v-model="record.month12" :disabled="type == 1" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                </template>
              </a-table-column>
          </a-table>

      </div>
      </div>
     
    </a-modal>
  </div>
</template>

<script>
import { accAdd } from '@/utils/precision'
import { getSubBudget ,addSubDetail} from '@/api/budget'
const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.child) {
      if (node.child.some((item) => item.id === key)) {
        parentKey = node.id
      } else if (getParentKey(key, node.child)) {
        parentKey = getParentKey(key, node.child)
      }
    }
  }
  return parentKey
}
export default {
    data() {
     return {
        // checkStrictly: false,
        type: '',
        keyYear: '',
        subList: [],
        queryParam: '',
        subTree: [],
        subVisible: false,
        replaceFields: {
          title: 'name',
          key: 'id',
          children: 'child',
        },
        expandedKeys: [],
        autoExpandParent: true,
        checkedSub: [],
        flag: '',
        index: '',
        selectTree: [],
        recordData: [],
        addType: 0,
     }},
    methods: {
      deleteItem(record){
         for(var j=this.checkedSub.length-1; j>=0; j-- ){
           if(this.checkedSub[j] == record.id) {
             console.log(this.checkedSub[j], 'this.checkedSub[j]====================')
             this.checkedSub.splice(j,1)
          }
        }
        console.log(record,this.checkedSub, '=========================')
        for(var i=this.subList.length-1;i>=0;i--){
           if(this.subList[i].id == record.id) {
             this.subList.splice(i,1)
          }
        }
        
        

      },
      subAdd() {
        console.log('1111111111111111')
        var num1 = 0
        var num2 = 0
        var num3 = 0
        var num4 = 0
        var num5 = 0
        var num6 = 0
        var num7 = 0
        var num8 = 0
        var num9 = 0
        var num10 = 0
        var num11 = 0
        var num12 = 0
        this.subList.forEach(item => {
          num1 = accAdd(num1,item.month1)
          num2 = accAdd(num2,item.month2)
          num3 = accAdd(num3,item.month3)
          num4 = accAdd(num4,item.month4)
          num5 = accAdd(num5,item.month5)
          num6 = accAdd(num6,item.month6)
          num7 = accAdd(num7,item.month7)
          num8 = accAdd(num8,item.month8) 
          num9 = accAdd(num9,item.month9)
          num10 = accAdd(num10,item.month10)
          num11 = accAdd(num11,item.month11)
          num12 = accAdd(num12,item.month12)
        })
        console.log(num1, num2)
        //获取左侧选中数组
        // var data = []
        //   function select(subTree, checkedSub) {
        //     subTree.forEach(item => {
        //     checkedSub.forEach(item1 => {
        //       if(item.id == item1) {
        //         console.log(item,item1)
        //         data.push(item)
        //       }else if(item.child && item.child.length) {
        //           select(item.child,checkedSub)
        //         }
        //     })
        //   })
        //   }
        //   select(this.subTree, this.checkedSub)
        //   this.selectTree = data
        //   console.log( this.selectTree, ' this.selectTree===============')
        this.$emit('addSubValue', {
          num1: num1,
          num2: num2,
          num3: num3,
          num4: num4,
          num5: num5,
          num6: num6,
          num7: num7,
          num8: num8,
          num9: num9,
          num10: num10,
          num11: num11,
          num12: num12,
          checkedSub: this.checkedSub,
          subList: this.subList,
          addType: this.addType,
        })
        this.subTree = []
        this.subList = []
        this.checkedSub = []
        this.subVisible = false
      },
        init(data) {
          console.log(data, 'data===================') 
          var subData = JSON.parse(JSON.stringify(data))
          // this.checkStrictly = false
          this.type = data.type
          this.addType = data.addType
              this.keyYear = data.rowData.start_year
              console.log(data.rowData, 'data.rowData.===================')
            var child_budget_dimension = data.rowData.child_budget_dimension
            if(child_budget_dimension == '各单据模板（费用类型）') {
            
              this.flag = false
                console.log(this.flag, 'this.flag1111111111==============')
            } else {
              console.log(this.flag, 'this.flag222222222222==============')
              this.flag = true
            }
            console.log(this.flag, 'this.flag==============')
              
              getSubBudget({
                id: data.rowData.id,
                flag: this.flag
                }).then(res => {
                // this.subTree = res.data
                var data = res.data
                function slot(lis) {
                  lis.forEach((item) => {
                    item['slots'] = item
                    item['scopedSlots'] = { icon: 'file-text', title: 'custom' }
                    if (item.child && item.child.length) {
                      slot(item.child)
                    }
                  })
                }
                slot(data)
                this.subVisible = true
                console.log(data, 'data=================')
                this.subTree = data;
                  if(subData.addType == 1) {
                  } else {
                    this.index = subData.index
                    console.log(subData.record, 'record=========')
                      this.recordData = subData.record
                      if(subData.record && subData.record.subsetIds && subData.record.subsetIds.length) {
                        // 1、回选已经选中的数据
                        // this.checkStrictly = true
                        this.checkedSub = subData.record.subsetIds
                        this.expandedKeys = subData.record.subsetIds
                         this.autoExpandParent = true
                        // 2、回填已有数据
                        this.subList = subData.record.subsetObjects
                        //  this.$forceUpdate()
                        //  setTimeout(() => {
                        //     this.checkStrictly = false
                        //   },5000)

                      }
                  }




               
                // this.$nextTick(() => {
                // })
              })
         
         
        },
        closeSub() {
          this.subTree = []
          this.subList = []
          this.checkedSub = []
          this.subVisible = false
          this.queryParam = ''
          this.expandedKeys = []
          this.autoExpandParent = false

        },
        //提交子预算
        addSub() {
          addSubDetail({
            flag: this.flag,
            key: this.checkedSub,
          }).then(res => {
            if(res.code == 200) {
                  //对比左右数据是否新增
              if(this.subList.length>0) {
                var data = []
                res.data.forEach(item => {
                  this.subList.forEach(item1 => {
                      if(item.id == item1.id) {
                        console.log(item, item1,'=================')
                          data.push(item1)
                      }
                    })
                  })
                  data.forEach(item => {
                      for(var i=res.data.length-1;i>=0;i--){
                        if(item.id == res.data[i].id) {
                          res.data.splice(i,1)
                        }
                    }

                  })
                  
                this.subList = [...data,...res.data]
                console.log(this.subList, 'subList=====')
              } else {
                this.subList = res.data
              }
              
            }
          })
        },
        //选择子预算
        onCheck(checkedKeys, e) {
          console.log(checkedKeys, e.node.dataRef,'checkedKeys===============')
          this.selectTree = []
          // console.log([...checkedKeys, ...e.halfCheckedKeys], 'checkedKeys====')
          this.checkedSub = checkedKeys
          this.addSub()
          
          // this.subTree.forEach(item => {
          //   this.checkedSub.forEach(item1 => {
          //     if(item.id == item1) {
          //       this.selectTree.push(item)
          //       if(item.child) {

          //       }

          //     }

          //   })

          // })
          

          
        },
        onExpand(expandedKeys) {
          this.expandedKeys = expandedKeys
          this.autoExpandParent = false
        },
        onChange(e) {
          var dataList = []
          function slot(lis) {
            for (let i = 0; i < lis.length; i++) {
              const node = lis[i]
              const key = lis[i].id
              dataList.push({ key, name: lis[i].name })
              if (node.child && node.child.length) {
                slot(node.child)
              }
            }
          }
          slot(this.subTree)
          console.log(dataList)
          const expandedKeys = dataList
            .map((item) => {
              if (item.name.indexOf(this.queryParam) > -1) {
                return getParentKey(item.key, this.subTree)
              }
              return null
            })
            .filter((item, i, self) => item && self.indexOf(item) === i)
          this.expandedKeys = expandedKeys
          console.log( this.expandedKeys, ' this.expandedKeys=====================')
          this.searchValue = this.queryParam
          console.log(this.searchValue)
          // this.autoExpandParent = true
            if(this.searchValue) {
               this.autoExpandParent = true
            } else {
              this.expandedKeys = []
              this.autoExpandParent = false
              console.log(this.autoExpandParent,'this.autoExpandParent=====')
            }
        },
    }

}
</script>

<style lang="less" scoped>
// .center {
//   position: relative;
//   display: block;
// }
.centerBox {
  // height: 500px;
  width: 100%;
  // width: 25%;
  display: inline-block;
  // overflow-y: scroll;
  // background-color: rgb(66, 150, 59);
  .top {
    margin-bottom: 5px;
    // position: absolute;
    // display: block;
    // margin: 5px;
  }
  .bottom {
    height: 500px;
    width: 100%;
    display: inline-block;
    overflow-y: scroll;
    &::-webkit-scrollbar{display: none;}
    // margin-top: 50px;
  }

}
.centerRight {
  
  height: 550px;
  width: 75%;
  display: none;
  // display: inline-block;
  overflow-y: scroll;
  &::-webkit-scrollbar{display: none;}
  border-left: 1px solid #ddd;
  // background-color: rgb(206, 43, 43);

}
   .view {
    width: 100%;
    border: 1px solid #409EFF;
    padding: 5px 50px 5px 0;
    margin-bottom: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #d9ecff;
    border-radius: 4px;
    color: #409EFF;

    .ico {
      width: 45px;
      height: 40px;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;

      .circle {
        font-size: 22px;
        color: #409EFF;
      }
    }

    .hiteBox {
      width: calc(100% - 45px);
      float: left;

      .hb {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 3px;
      }

    }

  }
</style>